import { ReactNode } from "react"
import { useNavigate } from "react-router-dom"
import { ArrowLeft } from "lucide-react"
import { Button } from "@/components/ui/button"
import { cn } from "@/lib/utils"
import { NotificationBell } from "@/features/notifications/NotificationBell"
import { UsageWidget } from "./UsageWidget"
import { StoreButtons } from "./StoreButtons"
import { SupportWidget } from "./SupportWidget"

interface PageHeaderProps {
  title: string
  subtitle?: string
  back?: boolean
  action?: ReactNode
  className?: string
}

export function PageHeader({ title, subtitle, back, action, className }: PageHeaderProps) {
  const navigate = useNavigate()
  return (
    <div
      className={cn(
        "sticky top-0 z-20 bg-background border-b border-border px-4 py-3 flex items-center justify-between gap-3",
        className
      )}
    >
      <div className="flex-1 min-w-0">
        <div className="flex items-center gap-2">
          {back && (
            <Button variant="ghost" size="icon" className="h-8 w-8 -ml-2 text-muted-foreground mr-1" onClick={() => navigate(-1)}>
              <ArrowLeft className="h-4 w-4" />
            </Button>
          )}
          <h1 className="text-xl md:text-2xl font-bold tracking-tight truncate">{title}</h1>
        </div>
        {subtitle && (
          <p className="text-sm text-muted-foreground font-medium mt-0.5 truncate max-w-2xl">{subtitle}</p>
        )}
      </div>

      <div className="flex items-center gap-2 shrink-0">
        {action && <div>{action}</div>}
        <StoreButtons size="sm" className="hidden md:flex" />
        <UsageWidget />
        <div className="hidden md:flex">
          <SupportWidget />
        </div>
        <NotificationBell />
      </div>
    </div>
  )
}
